import { Component } from '@angular/core';

@Component({
    templateUrl: 'pageNotFound.component.html',
    styleUrls: ['pageNotFound.component.scss'],
    standalone: false,
})
export class PageNotFoundComponent {}
